import React, {forwardRef} from 'react'
import {
    AspectRatio,
    Box,
    Skeleton as ChakraSkeleton,
    Stack,
    useMultiStyleConfig
} from '@chakra-ui/react'

// Component Skeleton
const ProductTileSkeleton = forwardRef((props, ref) => {
    const styles = useMultiStyleConfig('ProductTile', props)
    return (
        <Box ref={ref} data-testid="sf-product-tile-skeleton" position="relative" {...props}>
            <Stack {...styles.container}>
                <Box {...styles.imageWrapper}>
                    <AspectRatio ratio={7 / 8}>
                        <Box {...styles.imageContainer}>
                            <ChakraSkeleton {...styles.image} />
                        </Box>
                    </AspectRatio>
                </Box>
                <ChakraSkeleton width="50%" height="20px" />
                <ChakraSkeleton width="100%" height="12px" />
            </Stack>
        </Box>
    )
})

if (process.env.NODE_ENV !== 'production') {
    ProductTileSkeleton.displayName = 'ProductTileSkeleton'
}

export default ProductTileSkeleton
